import React from "react";
import { Row } from "antd";

import "./StepperFormRow.less";

export const StepperFormRow = ({ children, containerClass = "" }) => (
  <Row gutter={[24, 0]} className={`stepper-form-row ${containerClass}`}>
    {children}
  </Row>
);
